import config from 'constants/config'

type OfferTypeItem = App.AppConfig['offerTypesList'][number]

export function getOfferTypesContent(navItems: Array<App.NavItem>, offerTypesList?: Array<OfferTypeItem>) {
  const showTile = (to: string) => navItems.find(navItem => navItem.to === to)
  const items = offerTypesList ?? config.offerTypesList

  const outputNavItems = items.map(x => ({
    ...x,
    show: showTile(x.to),
  }))

  return outputNavItems
}
